import React from "react";
import Modal from 'react-responsive-modal';
import trainImage from "../../imgs/train-reverse.png";

import { Link, Switch, Route } from 'react-router-dom'

import $ from 'jquery';

import Train1 from './../docs/Train-1.js'
import Train2 from './../docs/Train-2.js';
import Train3 from './../docs/Train-3.js';

// Icons

import magnet from '../../icons/magnet.svg';
import train from '../../icons/train-icon.svg';
import atom from '../../icons/atom.svg';

export default class extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          open : false,
          modalContentOpen: false,
      }
  }


      onOpenModal = () => {
        this.setState({ open: true });
        $.fn.fullpage.setMouseWheelScrolling(false);
        $.fn.fullpage.setAllowScrolling(false);
        console.log('hi girls');
      };

      onCloseModal = () => {
        this.setState({ open: false });
        $.fn.fullpage.setMouseWheelScrolling(true);
        $.fn.fullpage.setAllowScrolling(true);
      };

      onOpenContentModal = () => {
        this.setState({modalContentOpen: true})
      }

      onCloseContentModal = () => {
        this.setState({modalContentOpen: false})
      }

  render() {
    return (
      <section className="train section ">
      <div className="row center-xs center-sm">
        <div className="col-xs-12 col-md-6 col-sm-6 col-lg-6">
          <img className="plane-img train__anim" src={trainImage} alt="alt"/>
        </div>
        <div className="col-xs-12 col-md-6 col-sm-6 col-lg-6">
          <div className="container">
            <div className="row center-xs start-lg start-sm start-md">
              <div className="col-xs-6 col-md-6 col-lg-6 col-sm-6">
                <h1 className="heading tesla-heading">Поезд на магнитной подушке</h1>
                <h2 className="subheading">Поезд на магнитной подушке, магнитоплан или маглев — это поезд, удерживаемый над полотном дороги, движимый и управляемый силой электромагнитного поля.</h2>
                <Link to=''>
                  <div onClick={this.onOpenModal} className="button">
                    <span className="button__mask"/>
                    <span className="button__text">Открыть</span>
                    <span className="button__text button__text--bis">Открыть</span>
                  </div>
                </Link>
                <Modal open={this.state.open} onClose={this.onCloseModal} little styles={
                  {
                    modal: {
                      padding: '2em',
                    }
                  }
                }>
                <div className='row center-xs modal'>
                  <div className='col-xs-4'>
                    <Link onClick={this.onOpenContentModal} className='link' to='/Train-1'>
                      <img alt='' className='responsive-icon' src={magnet} />
                      <p className='icon-heading'>Магнитная левитация</p>
                    </Link>
                  </div>
                  <div className='col-xs-4'>
                    <Link onClick={this.onOpenContentModal} className='link' to='/Train-2'>
                      <img alt='' className='responsive-icon' src={train} />
                      <p className='icon-heading'>Явление сверхпроводимости</p>
                    </Link>
                  </div>
                  <div className='col-xs-4'>
                    <Link onClick={this.onOpenContentModal} className='link' to='/Train-3'>
                      <img alt='' className='responsive-icon' src={atom} />
                      <p className='icon-heading'>Эффект Мейснера</p>
                    </Link>
                  </div>
                </div>
                </Modal>
                  <Modal open={this.state.modalContentOpen} onClose={this.onCloseContentModal}>
                    <Switch>
                    <Route exact path='/Train-1' component={Train1}/>
                    <Route exact path='/Train-2' component={Train2}/>
                    <Route exact path='/Train-3' component={Train3}/>
                  </Switch>
                  </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/Train.js